export function chr4() {
  return Math.random().toString(16).slice(-4)
}

export function createID(prefix: string) {
  return `${prefix}-${chr4()}${chr4()}-${chr4()}-${chr4()}-${chr4()}-${chr4()}${chr4()}${chr4()}`
}
